import {request} from '@/network/request'

/**
 * 列表接口
 * @param obj
 * @returns {AxiosPromise}
 */
export function getDirectoryByType(type) {
  return request({
    url: '/gaoligong/picturevideo/getDirectoryByType',
    method: 'get',
    params: {type}
  })
}
